import { IMSObject, IMSId, LabelFormatSetting } from './ims-object';

/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

export class Reason extends IMSObject {
  static fromDto(
    dto: ReasonDTO, 
    databag?: any,
    labelSettings?: LabelFormatSetting
  ) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: dto.secondaryid,
        objRef: 'ims/Reason',
      },
      dto.label,
      labelSettings || {
        primary: {
          value: '{0}',
          databagKeys: ['label'],
        }
      },
    );

    if (databag) {
      obj.databag = databag
    } else {
      obj.databag = dto;
    }
    return obj;
  }
  
  public get code() : number {
    return this.databag.code
  }
  public set code(v : number) {
    this.databag.code = v;
  }
  
  public get name() : string {
    return this.databag.name
  }
  public set name(v : string) {
    this.databag.name = v;
  }

  public get description() : string {
    return this.databag.description
  }
  public set description(v : string) {
    this.databag.description = v;
  }

  public get type() : string {
    return this.databag.type
  }
  public set type(v : string) {
    this.databag.type = v;
  }

  constructor(
    public readonly id: IMSId,
    label: string,
    labelFormatSettings: LabelFormatSetting,
  ) {
    super(id.imsId, id.secondaryId, label, 'ims/Reason', labelFormatSettings);
  }
}

export interface ReasonDTO {
  id: number;
  secondaryid: number;
  label: string;
}
